module.exports = __webpack_public_path__ + "images/white_bg-8389beec68.png";